import { Component } from "@angular/core";
import { CTableCell } from "../../../../core/ui/c-table/c-table-config";
import { DIGITAL_MEMORY_LOG_CONSTANTS } from "../../constants/digital-memory-log.constants";
import { isDigitalMemoryLogExpired } from "../../utils/digital-memory-log.utils";

@Component({
  selector: "app-digital-memory-log-expiry-col",
  template: `
    <div
      class="dml-expiry-cell"
      [class.is-expired]="isExpired(row.entity)"
      [title]="isExpired(row.entity) ? expiredTooltip : ''"
    >
      <span>{{ formatDate(row.entity.expiryDate) }}</span>
    </div>
  `,
  styles: [
    `
      .dml-expiry-cell.is-expired {
        color: #b91c1c;
        font-weight: 700;
      }
    `,
  ],
})
export class ExpiryDateColComponent implements CTableCell {
  extraData;
  row;
  column;
  readonly expiredTooltip = DIGITAL_MEMORY_LOG_CONSTANTS.MESSAGES.EXPIRED_TOOLTIP;

  isExpired(entity: any): boolean {
    return isDigitalMemoryLogExpired(entity);
  }

  formatDate(value: any): string {
    if (!value) {
      return "-";
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return String(value);
    }
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    const dd = (day < 10 ? "0" : "") + day;
    const mm = (month < 10 ? "0" : "") + month;
    return dd + "-" + mm + "-" + year;
  }
}
